const icon = require('./icons/toilet-100.png')

export const WashRoomIcon = () => {
  return <img src={icon} alt="toileting icon" className="w-full h-full"/>
}
